import { doc, getDoc } from "firebase/firestore";
import { db } from "../../services/firebase.config";
import dataCache from "../../services/DataCache";

export async function loadExistingInsights(userId, currentQuizData = []) {
  if (!userId) return { overview: null, individual: {} };

  try {
    let userData = dataCache.getUserProfile(userId);

    if (!userData) {
      const userProfileRef = doc(db, "public-profiles", userId);
      const userProfileDoc = await getDoc(userProfileRef);

      if (!userProfileDoc.exists()) return { overview: null, individual: {} };

      userData = userProfileDoc.data();
      dataCache.setUserProfile(userId, userData);
    }

    const profileOverview = userData.profileInsights?.content || null;

    const existingIndividualInsights = {};
    for (const quiz of currentQuizData) {
      if (quiz.insights) {
        existingIndividualInsights[quiz.quizType] = {
          content: quiz.insights,
          quizName: quiz.quizName,
          config: quiz.config,
        };
      }
    }

    console.log("📝 Found existing insights:", {
      hasOverview: !!profileOverview,
      individualCount: Object.keys(existingIndividualInsights).length,
      totalQuizzes: currentQuizData.length,
    });

    return {
      overview: profileOverview,
      individual: existingIndividualInsights,
    };
  } catch (err) {
    console.warn("Could not load existing insights:", err);
    return { overview: null, individual: {} };
  }
}
